export const convertToUnitTypeModalId = 'convert-to-unit-type';
